import { takeLatest, takeEvery } from 'redux-saga'
import { call, put, select } from 'redux-saga/effects'

import themesSelectors from 'redux/selectors/themes/themes_selector'
import actionTypes from 'redux/actions/actionTypes'
import themesSync from 'sync/themes_sync'

function *getThemesData(action) {
	try {
		const response = yield call(themesSync.getThemesData, action.slideId)
		if (response.error_code === 0) {
			yield put({
				type: actionTypes.THEMES_SET_ALL,
				payload: response.payload,
			})
		} else {
			yield put({
				type: actionTypes.SYNC_UNCAUGHT_ERROR,
				payload: response.payload,
			})
		}
	} catch (error) {
		// console.log(error)
	}
}

function *themeChange(action) {
	try {
		// TODO: review what is this doing. A select with no usage and then a new action?
		yield select(themesSelectors.getListData)
		yield put({
			type: actionTypes.THEMES_CHANGE_SUCCESS,
			themeId: action.themeId,
		})
	} catch (error) {
		// console.log(error)
	}
}

export default [
	takeLatest(actionTypes.THEMES_INITIALIZE, getThemesData),
	takeEvery(actionTypes.THEMES_CHANGE, themeChange),
]
